import type { RouteObject } from "react-router";
import { redirect } from "react-router";

/** Address of the Languages screen (T09-28) — linked from the theme editor's settings (T09-24). */
export const LANGUAGES_PATH = "/online-store/languages";

/** Content (design/04 §10) + Online store → Languages (§11) — inside the admin layout. */
export const contentRoutes: RouteObject[] = [
  { path: "content", loader: () => redirect("/content/pages") },
  {
    path: "content/pages",
    lazy: async () => ({ Component: (await import("./pages/PagesListPage")).PagesListPage }),
  },
  {
    path: "content/pages/:pageId",
    lazy: async () => ({ Component: (await import("./pages/PageEditorPage")).PageEditorPage }),
  },
  {
    path: "content/policies",
    lazy: async () => ({ Component: (await import("./policies/PoliciesPage")).PoliciesPage }),
  },
  {
    path: "content/policies/:type",
    lazy: async () => ({
      Component: (await import("./policies/PolicyEditorPage")).PolicyEditorPage,
    }),
  },
  {
    path: "content/menus",
    lazy: async () => ({ Component: (await import("./menus/MenusPage")).MenusPage }),
  },
  {
    path: "content/menus/:menuId",
    lazy: async () => ({ Component: (await import("./menus/MenuEditorPage")).MenuEditorPage }),
  },
  {
    path: "content/redirects",
    lazy: async () => ({ Component: (await import("./redirects/RedirectsPage")).RedirectsPage }),
  },
  {
    path: "content/announcements",
    lazy: async () => ({
      Component: (await import("./announcements/AnnouncementsPage")).AnnouncementsPage,
    }),
  },
  {
    path: "content/translations",
    lazy: async () => ({
      Component: (await import("./translations/TranslationsPage")).TranslationsPage,
    }),
  },
  {
    path: "content/website-texts",
    lazy: async () => ({ Component: (await import("./translations/UiStringsPage")).UiStringsPage }),
  },
  {
    path: "content/media",
    lazy: async () => ({ Component: (await import("./media/MediaLibraryPage")).MediaLibraryPage }),
  },
  {
    path: LANGUAGES_PATH.slice(1),
    lazy: async () => ({
      Component: (await import("../online-store/LocalizationPage")).LocalizationPage,
    }),
  },
];
